<template>
  <div>
    <FactoryMaterial :order-id="orderId" ref="r0"></FactoryMaterial>
    <PurchaseReport :order-id="orderId" ref="r1"></PurchaseReport>
    <MakeReport :order-id="orderId" ref="r2"></MakeReport>
    <MoneyReport :order-id="orderId" ref="r3"></MoneyReport>
  </div>
</template>

<script>
import FactoryMaterial from '@/views/modules/settle/report/factory-material.vue'
import MoneyReport from '@/views/modules/settle/report/money'
import PurchaseReport from './purchase.vue'
import MakeReport from './make.vue'
export default {
  name: 'SettleReport',
  components: { PurchaseReport, MakeReport, MoneyReport,FactoryMaterial },
  props: {
    orderId: '',
    orderCode: ''
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
